import { render } from "./Token.vue?vue&type=template&id=381b468c"
import script from "./Token.vue?vue&type=script&lang=ts"
export * from "./Token.vue?vue&type=script&lang=ts"
script.render = render

export default script